import { Injectable } from '@angular/core';

import { LocalStorageService } from 'ngx-webstorage';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Router} from '@angular/router';
import {isNullOrUndefined} from 'util';
//import {ConfirmNavigationService} from "./authenticated/maps/common/confirm-navigation/confirm-navigation.service";
import { ApiUrlService } from './api-url.service';
import { ApplicationStateService } from './application-state.service';
import { newAuthenticatedUser, TokenResponse } from '../../api/datacleanuptool-api.model';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  redirectUrl: string;

  get isLoggedIn() : boolean {
    return this.localStorageService.retrieve('token');
  }

  constructor(
    private localStorageService: LocalStorageService,
    private apiService: ApiUrlService,
    private accountService: AccountService,
    private applicationStateService: ApplicationStateService,
   // private confirmNavigationService: ConfirmNavigationService,
    private router: Router
  ) { }

  logIn(email: string, password: string): Observable<boolean> {
    return this.apiService.postAuth<TokenResponse, any>({ email, password }, `authentication-tokens` )
      .pipe( map(userData => {
        if (!isNullOrUndefined(userData) && !isNullOrUndefined(userData.token)) {
          // login successful if there's a jwt token in the response
          this.updateToken(userData.token);
          this.accountService.setCurrentUser(
            newAuthenticatedUser({firstName: userData.firstName, lastName: userData.lastName, email: email}));
          return true;
        }
        return false;
      }));
  }


  private logOut(): void {
    this.clearLoginInfo();
    this.redirectUrl = undefined;
//    this.confirmNavigationService.allowLeave$.next(true);
  }

  public clearLoginInfo() {
    this.localStorageService.clear('token');
    this.localStorageService.clear('currentUser');
    this.applicationStateService.clearSelectedCollege();
  }

  logOutAndRedirect(): void {
    this.logOut();
    this.router.navigate(['/login']);
  }

  redirectToLogin(): void {
    this.router.navigate(['/login']);
  }

  updateToken(newToken: string) {
    this.localStorageService.store('token', newToken);
  }
}
